import data2025 from './2025.json';
import data2026 from './2026.json';

// The following assignments are for runtime validation only in JS.
const v2025 = data2025;
const v2026 = data2026;

const AVAILABLE = {
    [v2025.year]: v2025,
    [v2026.year]: v2026,
};

const CURRENT_YEAR = new Date().getFullYear();

function getValuesForYear(year = CURRENT_YEAR) {
    const exact = AVAILABLE[year];
    if (exact) return exact;

    const years = Object.keys(AVAILABLE).map(y => Number(y)).sort((a, b) => a - b);
    // eslint-disable-next-line no-plusplus
    for (let i = years.length - 1; i >= 0; i--) {
        if (years[i] <= year) return AVAILABLE[years[i]];
    }
    return AVAILABLE[years[0]];
}

export const VALUES = getValuesForYear();

export default { getValuesForYear, VALUES };
